import { Box, Typography, Button } from "@mui/material";

const SaleInvoiceItems = ({ data, onChange }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Invoice Items</Typography>
      <Typography>Add logic here for product rows, taxes, etc.</Typography>
      <Button onClick={() => onChange("rows", [...data.rows, {}])}>Add Row</Button>
    </Box>
  );
};

export default SaleInvoiceItems;